import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';
import { ProfilePageHeaderSkeleton } from '../../shared/ProfilePageHeaderSkeleton';

export const EditFamilyPageSkeleton = () => {
  return (
    <Box>
      <ProfilePageHeaderSkeleton />
      <Skeleton sx={{ mb: 1.5 }} width="15rem" height="1.5rem" variant="rectangular" />
      <Grid container spacing={2.5}>
        {_.times(4, _.stubArray).map((_item, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Skeleton width="10rem" />
            <Skeleton variant="rectangular" height="3rem" width="100%" />
          </Grid>
        ))}
      </Grid>
      <Grid container sx={{ pt: 2.5 }} spacing={2.5}>
        {_.times(2, _.stubArray).map((_item, index) => (
          <Grid key={index} item>
            <Skeleton variant="rectangular" height="3rem" width="7.5rem" />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
